// Realistic Kenyan IT-services sample leads to seed a fresh CRM.

const today = () => new Date();
const daysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d; };
const daysAhead = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };

export const SAMPLE_LEADS = [
  {
    companyName: 'Equity Group Holdings',
    industry: 'Banking', contactName: 'James Mwangi',
    phone: '+254700111222', email: 'procurement@equitybank.co.ke',
    stage: 'Qualified', productInterest: 'Cybersecurity', leadSource: 'LinkedIn Personal',
    dateAdded: daysAgo(40), nextAction: 'SOC assessment scoping call',
    nextActionDate: daysAhead(3), notes: 'Interested in SOC-as-a-service for branch network.',
    estimatedMonthlyValueKES: 850000
  },
  {
    companyName: 'Twiga Foods',
    industry: 'AgriTech / Logistics', contactName: 'Caroline Wanjiku',
    phone: '+254712334455', email: 'caro@twigafoods.com',
    stage: 'Presentation', productInterest: 'Odoo Advisory', leadSource: 'Referral',
    dateAdded: daysAgo(28), nextAction: 'Founder demo of inventory module',
    nextActionDate: daysAhead(2), notes: 'Replacing legacy ERP in 6 hubs across Nairobi & Mombasa.',
    estimatedMonthlyValueKES: 420000
  },
  {
    companyName: 'Safaricom Business',
    industry: 'Telecommunications', contactName: 'Peter Ndegwa',
    phone: '+254722010203', email: 'business@safaricom.co.ke',
    stage: 'Engaged', productInterest: 'Managed IT', leadSource: 'LinkedIn Company',
    dateAdded: daysAgo(15), nextAction: 'Send case studies on Tier-2 retail rollout',
    nextActionDate: daysAhead(5), notes: 'They\'ve asked for B1S references in financial services.',
    estimatedMonthlyValueKES: 1200000
  },
  {
    companyName: 'Kenya Commercial Bank',
    industry: 'Banking', contactName: 'Paul Russo',
    phone: '+254733445566', email: 'it.tenders@kcbgroup.com',
    stage: 'Negotiation', productInterest: 'Cybersecurity', leadSource: 'Cold Call',
    dateAdded: daysAgo(60), nextAction: 'Final pricing & SLA review',
    nextActionDate: daysAhead(7), notes: 'Awaiting CFO sign-off; competitive vs. Liquid C2.',
    estimatedMonthlyValueKES: 1800000
  },
  {
    companyName: 'Bidco Africa',
    industry: 'Manufacturing / FMCG', contactName: 'Vimal Shah',
    phone: '+254755667788', email: 'cio@bidcoafrica.com',
    stage: 'Contacted', productInterest: 'NAWIRI', leadSource: 'Event',
    dateAdded: daysAgo(8), nextAction: 'Follow up on NAWIRI deck',
    nextActionDate: daysAhead(1), notes: 'Met at Africa Tech Summit. Plant in Thika needs uptime audit.',
    estimatedMonthlyValueKES: 320000
  },
  {
    companyName: 'Jubilee Insurance',
    industry: 'Insurance', contactName: 'Nizar Juma',
    phone: '+254700998877', email: 'enquiries@jubileeinsurance.com',
    stage: 'Prospect', productInterest: 'Managed IT', leadSource: 'Lusha Email',
    dateAdded: daysAgo(3), nextAction: 'Initial outreach email',
    nextActionDate: daysAhead(1), notes: 'Outdated endpoint management — opportunity for Managed IT bundle.',
    estimatedMonthlyValueKES: 0
  },
  {
    companyName: 'Naivas Supermarkets',
    industry: 'Retail', contactName: 'Willy Kimani',
    phone: '+254766112233', email: 'it@naivas.co.ke',
    stage: 'Qualified', productInterest: 'Odoo Advisory', leadSource: 'Website',
    dateAdded: daysAgo(20), nextAction: 'POS integration scoping',
    nextActionDate: daysAhead(4), notes: '90+ branches; needs unified POS & inventory.',
    estimatedMonthlyValueKES: 650000
  },
  {
    companyName: 'I&M Bank',
    industry: 'Banking', contactName: 'Kihara Maina',
    phone: '+254711889900', email: 'procurement@imbank.com',
    stage: 'Closed Won', productInterest: 'Cybersecurity', leadSource: 'Referral',
    dateAdded: daysAgo(80), nextAction: 'Quarterly business review',
    nextActionDate: daysAhead(30), notes: 'Signed 24-month MSSP retainer.',
    estimatedMonthlyValueKES: 950000
  },
  {
    companyName: 'Sendy Logistics',
    industry: 'Logistics', contactName: 'Mesh Alloys',
    phone: '+254722334455', email: 'ops@sendyit.com',
    stage: 'Closed Lost', productInterest: 'Managed IT', leadSource: 'LinkedIn Personal',
    dateAdded: daysAgo(50), nextAction: 'Re-engage in Q3',
    nextActionDate: daysAhead(60), notes: 'Lost on price; chose internal team. Stay in touch.',
    estimatedMonthlyValueKES: 0
  },
  {
    companyName: 'KenGen',
    industry: 'Energy / Utilities', contactName: 'Rebecca Miano',
    phone: '+254733445500', email: 'tenders@kengen.co.ke',
    stage: 'Nurture', productInterest: 'NAWIRI', leadSource: 'Historic CRM',
    dateAdded: daysAgo(120), nextAction: 'Resurface in 2026 capex cycle',
    nextActionDate: daysAhead(90), notes: 'Procurement freeze until Q3 2026.',
    estimatedMonthlyValueKES: 0
  }
];
